import IAlert from "@/models/modelView/IAlert";
import FormatDate from "@/utils/date.util";
import EventStrategy from "./event.strategy";
import DeviceUtil from "@/utils/device.util";

export default class OverspeedStrategy extends EventStrategy {

    mapEvent(): IAlert {
        return {
            data: [
                {
                    title: 'Fecha:',
                    value: FormatDate.getGenericFormat(this.event.eventTime) 
                },
                {
                    title: 'Límite:',
                    value: DeviceUtil.formatKnToKmh(this.event.attributes.speedLimit) + 'Km/h'
                },
                {
                    title: 'Velocidad:',
                    value: DeviceUtil.formatKnToKmh(this.event.attributes.speed) + 'Km/h'
                }

            ],
            ...this.eventBase()
        }
    }

}